"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClientOptionsFactory = void 0;
const config_1 = require("../config");
class AuthClientOptionsFactory {
    getAuthClientOptions() {
        return {
            domain: config_1.authDomain,
            clientId: config_1.authClientId,
            authorizationParams: {
                redirect_uri: `${window.location.origin}/login-new`,
                audience: config_1.authAudience,
                scope: 'openid profile email offline_access',
            },
            cacheLocation: 'localstorage',
            useRefreshTokens: true,
            useRefreshTokensFallback: true,
        };
    }
}
exports.AuthClientOptionsFactory = AuthClientOptionsFactory;
//# sourceMappingURL=AuthClientOptionsFactory.js.map